/**
 * Keep in sync with the `ReturnProcessingLevel` enum-source registration in
 * redo/backend/db/schema/src/team/RedoManagedReturnsSettings.ts.
 */
export enum ReturnProcessingLevel {
  VERIFICATION = "verification",
  GRADING = "grading",
}
